import React from "react";

const Spacer = (): JSX.Element => <div className="spacer">&#x200b;</div>;

export default Spacer;
